import { Translations } from './fr';

export const ar: Translations = {
  nav: {
    home: "الرئيسية",
    primeEvolution: "إيفوليوشن",
    pulse: "بولس",
    sparkle: "سباركل",
    agents: "الوكلاء",
    partners: "الشركاء",
    contact: "اتصل بنا",
    recruitAgent: "توظيف وكيل",
  },
  hero: {
    title: "وظّف",
    titleHighlight: "وكلاء الذكاء الاصطناعي",
    titleEnd: "لتعزيز فرقك",
    subtitle: "متعاونون افتراضيون متاحون على مدار الساعة، مدربون على عمليات أعمالك، جاهزون لتحويل إنتاجيتك.",
    cta: "توظيف وكيل ذكاء اصطناعي",
    discover: "اكتشف برايم إيفوليوشن",
  },
  trust: {
    available: "متاح 24/7",
    secure: "آمن 100%",
    agents: "وكلاء معتمدون",
    support: "دعم مخصص",
  },
  primeEvolution: {
    badge: "حلنا الرائد",
    title: "برايم إيفوليوشن",
    subtitle: "برنامج الدعم الكامل لدمج الذكاء الاصطناعي في شركتك",
    description: "برايم إيفوليوشن هو نهجنا الشامل الذي يجمع بين التدقيق والتدريب ونشر وكلاء الذكاء الاصطناعي المخصصين.",
    features: {
      audit: { title: "تدقيق استراتيجي", description: "تحليل معمق لعملياتك لتحديد فرص الأتمتة." },
      training: { title: "تدريب الفريق", description: "برامج تدريب مكيفة للتعاون الفعال مع الذكاء الاصطناعي." },
      deployment: { title: "نشر مخصص", description: "وكلاء ذكاء اصطناعي مخصصون متكاملون مع أدواتك الحالية." },
      support: { title: "دعم مستمر", description: "دعم مخصص وتحسين مستمر." },
    },
    cta: "ابدأ برايم إيفوليوشن",
    stats: { productivity: "متوسط زيادة الإنتاجية", roi: "العائد على الاستثمار", satisfaction: "معدل رضا العملاء" },
  },
  pulse: {
    badge: "أتمتة ذكية",
    title: "فيكتوريا بولس",
    subtitle: "أتمتة تنبض بإيقاع شركتك",
    description: "بولس هي منصة الأتمتة الذكية لدينا التي تربط وتنسق سير العمل في الوقت الفعلي.",
    features: {
      connect: { title: "اتصل", description: "تكامل أصلي مع أكثر من 200 أداة مهنية." },
      orchestrate: { title: "نسّق", description: "سير عمل ذكي يتكيف تلقائياً." },
      optimize: { title: "حسّن", description: "تحليل في الوقت الفعلي وتوصيات لتحسين العمليات." },
    },
    cta: "اكتشف بولس",
  },
  advantages: {
    badge: "لماذا تختارنا",
    title: "مزايا فيكتوريا",
    subtitle: "نهج فريد يجمع بين الخبرة البشرية وقوة الذكاء الاصطناعي",
    items: {
      expertise: { title: "خبرة معترف بها", description: "أكثر من 10 سنوات من الخبرة في التحول الرقمي والذكاء الاصطناعي." },
      custom: { title: "حلول مخصصة", description: "كل وكيل مدرب خصيصاً على عملياتك." },
      security: { title: "أمان أقصى", description: "البيانات مستضافة في أوروبا، امتثال GDPR مضمون." },
      roi: { title: "عائد استثمار مضمون", description: "التزام بالنتائج مع مؤشرات قابلة للقياس." },
      support: { title: "دعم 24/7", description: "فريق مخصص متاح في أي وقت." },
      evolution: { title: "تطور مستمر", description: "وكلاؤك يتحسنون باستمرار عبر التعلم الآلي." },
    },
  },
  sparkle: {
    badge: "الرقمنة الذكية",
    title: "Sparkle",
    subtitle: "TagPDF v7 مع الذكاء الاصطناعي",
    description: "حوّل مستنداتك الورقية إلى بيانات قابلة للاستخدام مع حلنا للرقمنة الذكية. التعرف التلقائي واستخراج البيانات والتصنيف الذكي.",
    features: {
      scan: {
        title: "الرقمنة المتقدمة",
        description: "OCR عالي الدقة لجميع أنواع المستندات.",
      },
      ai: {
        title: "الذكاء الاصطناعي المدمج",
        description: "تصنيف واستخراج تلقائي للبيانات الرئيسية.",
      },
      speed: {
        title: "معالجة فائقة السرعة",
        description: "معالجة آلاف الصفحات في دقائق.",
      },
      accuracy: {
        title: "أقصى دقة",
        description: "معدل التعرف يتجاوز 99%.",
      },
    },
    cta: "اكتشف Sparkle",
    ctaFulltext: "فهرسة النص الكامل",
    ctaFulltextDesc: "ابحث فوراً في جميع مستنداتك.",
    ctaScan: "مسح البرق ← مجلد",
    ctaScanDesc: "امسح ونظم في لمح البصر.",
  },
  testimonials: {
    badge: "شهادات",
    title: "يثقون بنا",
    subtitle: "اكتشف كيف يحول عملاؤنا أعمالهم مع فيكتوريا",
    items: [
      { quote: "بفضل VEECTORIA، قللنا المهام الإدارية بنسبة 70%.", metric: "-70%", metricLabel: "الوقت الإداري", name: "إيزابيل ج.", role: "مديرة إدارية" },
      { quote: "حوّل وكيل الذكاء الاصطناعي التجاري التنقيب لدينا. +40% مواعيد مؤهلة.", metric: "+40%", metricLabel: "مواعيد مؤهلة", name: "مارك د.", role: "مدير المبيعات" },
      { quote: "حل الوثائق يوفر لنا وقتاً ثميناً في إدارة الملفات.", metric: "5x", metricLabel: "أسرع", name: "صوفي م.", role: "مديرة" },
    ],
  },
  faq: {
    badge: "الأسئلة الشائعة",
    title: "كل شيء عن فيكتوريا",
    subtitle: "إجابات على أسئلتك الأكثر شيوعاً",
    items: {
      q1: { question: "ما هو وكيل فيكتوريا للذكاء الاصطناعي؟", answer: "متعاون افتراضي ذكي مدرب على عمليات أعمالك المحددة." },
      q2: { question: "كم يستغرق النشر؟", answer: "النشر القياسي يستغرق 2-4 أسابيع، للاحتياجات الأكثر تعقيداً 6-8 أسابيع." },
      q3: { question: "هل بياناتي آمنة؟", answer: "بالتأكيد. جميع البيانات مستضافة في أوروبا على خوادم معتمدة، 100% متوافقة مع GDPR." },
      q4: { question: "ما هو العائد المتوقع على الاستثمار؟", answer: "عملاؤنا يحققون زيادة إنتاجية بنسبة 40% وعائد إيجابي في 3 أشهر." },
      q5: { question: "كيف يعمل التكامل؟", answer: "فيكتوريا تتكامل أصلياً مع أكثر من 200 أداة مهنية." },
    },
  },
  contact: {
    badge: "اتصل بنا",
    title: "مستعد لتحويل شركتك؟",
    subtitle: "دعنا نناقش احتياجاتك واكتشف كيف يمكن لفيكتوريا دعمك",
    form: {
      name: "الاسم الكامل",
      email: "البريد الإلكتروني المهني",
      company: "الشركة",
      phone: "الهاتف",
      message: "رسالتك",
      submit: "إرسال الرسالة",
      sending: "جاري الإرسال...",
      success: "تم إرسال الرسالة بنجاح!",
      error: "خطأ في الإرسال. يرجى المحاولة مرة أخرى.",
    },
    info: { title: "معلومات الاتصال", email: "البريد الإلكتروني", phone: "الهاتف", address: "العنوان" },
  },
  cta: {
    title: "مستعد للعمل؟",
    subtitle: "انضم إلى الشركات التي حولت إنتاجيتها بالفعل مع فيكتوريا",
    button: "توظيف وكيل ذكاء اصطناعي",
  },
  footer: {
    description: "حلول الذكاء الاصطناعي لتحويل شركتك.",
    navigation: "التنقل",
    legal: "إشعار قانوني",
    privacy: "سياسة الخصوصية",
    terms: "الشروط والأحكام",
    cookies: "إعدادات ملفات تعريف الارتباط",
    rights: "جميع الحقوق محفوظة.",
  },
  agents: {
    badge: "فريقنا",
    title: "وكلاء الذكاء الاصطناعي لدينا",
    subtitle: "اكتشف متعاونينا الافتراضيين المستعدين للانضمام إلى فريقك",
  },

  // AI Agents Showcase
  agentsShowcase: {
    badge: "تميز الذكاء الاصطناعي في خدمة شركتك",
    title: "وكلاؤنا الذكيون يحولون عملك اليومي",
    description: "تخيل فريقاً من المتعاونين الافتراضيين الذين لا ينامون أبداً، يتعلمون باستمرار ويتكيفون تماماً مع عمليات عملك. وكلاء الذكاء الاصطناعي لدينا يضاعفون قدراتك، ويحررون مواهبك من المهام المتكررة، ويرفعون إنتاجيتك إلى آفاق جديدة.",
    imageAlt: "فريق وكلاء الذكاء الاصطناعي VEECTORIA",
    cta: "اكتشف وكلاءنا",
    benefits: {
      availability: "متاح على مدار الساعة",
      productivity: "إنتاجية x10",
      performance: "أداء مثالي",
      collaboration: "تعاون سلس",
    },
  },
  cookies: {
    title: "إدارة ملفات تعريف الارتباط",
    message: "نستخدم ملفات تعريف الارتباط لتحسين تجربتك على موقعنا، وتحليل حركة المرور، وتخصيص المحتوى.",
    accept: "قبول الكل",
    decline: "رفض",
    settings: "تخصيص",
    settingsTitle: "إعدادات ملفات تعريف الارتباط",
    settingsDescription: "قم بإدارة تفضيلات ملفات تعريف الارتباط الخاصة بك. ملفات تعريف الارتباط الأساسية ضرورية لعمل الموقع ولا يمكن تعطيلها.",
    saveChoices: "حفظ اختياراتي",
    rejectAll: "رفض الكل",
    alwaysActive: "نشط دائماً",
    categories: {
      essential: { name: "ملفات تعريف الارتباط الأساسية", description: "هذه الملفات ضرورية لعمل الموقع ولا يمكن تعطيلها." },
      analytics: { name: "ملفات تعريف الارتباط التحليلية", description: "تتيح لنا هذه الملفات قياس جمهور الموقع وتحليل سلوك التصفح." },
      marketing: { name: "ملفات تعريف الارتباط التسويقية", description: "تُستخدم هذه الملفات لتقديم إعلانات مخصصة." },
      preferences: { name: "ملفات تعريف الارتباط للتفضيلات", description: "تتذكر هذه الملفات تفضيلاتك (اللغة، المظهر، المنطقة)." },
    },
  },

  // Partners Section
  partners: {
    badge: "برنامج الشراكة",
    title: "لنبني معاً",
    description: "هل أنت موزع أو تاجر جملة أو ناشر برمجيات؟ فيكتوريا تصبح شريكك التكنولوجي المفضل لغزو أسواق جديدة بحلول الذكاء الاصطناعي المتطورة.",
    valueProposition: "نصمم ونطور حلولاً احترافية كاملة ومخصصة لعملائك، مع دعمك في تنفيذ استراتيجية تسويق جماعي. هوامش جذابة، دعم تقني مخصص، ومساعدة تسويقية: جميع مكونات نجاحك.",
    types: {
      resellers: { title: "الموزعون", description: "ادمج حلول الذكاء الاصطناعي لدينا في كتالوجك وقدم عروضاً مميزة." },
      distributors: { title: "الموزعون الإقليميون", description: "انشر تقنياتنا على نطاق واسع في منطقتك." },
      editors: { title: "ناشرو البرمجيات", description: "عزز برنامجك بذكائنا الاصطناعي لقيمة مضافة لا مثيل لها." },
      wholesalers: { title: "تجار الجملة", description: "احصل على أسعار تفضيلية للتوزيع الجماعي عبر شبكاتك." },
    },
    benefits: {
      title: "مزايا الشراكة",
      whiteLabel: "حلول العلامة البيضاء",
      support: "دعم تقني مخصص",
      scalability: "قابلية توسع غير محدودة",
    },
    cta: "كن شريكاً",
    ctaSubtext: "اتصل بنا لاكتشاف برنامج الشركاء الحصري",
  },

  legal: {
    lastUpdate: "آخر تحديث: يناير 2026",
    mentions: {
      title: "إشعار قانوني",
      sections: {
        editor: { title: "1. ناشر الموقع", intro: "هذا الموقع منشور من قبل:", companyName: "الاسم التجاري", legalForm: "الشكل القانوني", capital: "رأس المال", address: "المقر الرئيسي", siren: "SIREN", siret: "SIRET", rcs: "RCS", tva: "رقم ضريبة القيمة المضافة", naf: "رمز NAF" },
        publication: { title: "2. مدير النشر", intro: "النشر يُدار من قبل:", since: "منذ" },
        contact: { title: "3. الاتصال", phone: "الهاتف", email: "البريد الإلكتروني" },
        hosting: { title: "4. الاستضافة", intro: "الموقع مستضاف من قبل:", name: "الاسم", address: "العنوان" },
        intellectual: { title: "5. الملكية الفكرية", content1: "هذا الموقع بالكامل يخضع للتشريعات الفرنسية والدولية بشأن حقوق النشر والملكية الفكرية.", content2: "يُحظر إعادة إنتاج هذا الموقع كلياً أو جزئياً دون إذن صريح من" },
        liability: { title: "6. تحديد المسؤولية", content: "المعلومات على هذا الموقع دقيقة قدر الإمكان. {company} لا يمكن أن تتحمل المسؤولية عن الأضرار المباشرة أو غير المباشرة الناتجة عن استخدام هذا الموقع." },
        law: { title: "7. القانون المطبق", content: "يخضع هذا الموقع للقانون الفرنسي. في حالة النزاع، تكون المحاكم الفرنسية هي المختصة حصرياً." },
      },
    },
    privacy: {
      title: "سياسة الخصوصية",
      sections: {
        intro: { title: "1. مقدمة", content: "{company} تلتزم بحماية خصوصية مستخدمي موقعها. توضح هذه السياسة كيف نجمع ونستخدم ونحمي بياناتك الشخصية وفقاً للائحة حماية البيانات العامة (GDPR)." },
        controller: { title: "2. المسؤول عن المعالجة", company: "الشركة", address: "العنوان", email: "البريد الإلكتروني" },
        data: { title: "3. البيانات المجمعة", intro: "نجمع البيانات التالية:", items: ["بيانات التعريف: الاسم، اللقب، البريد الإلكتروني، الهاتف", "البيانات المهنية: الشركة، المنصب", "بيانات التصفح: عنوان IP، ملفات تعريف الارتباط، الصفحات المزارة", "بيانات الاتصال: الرسائل عبر النماذج"] },
        purposes: { title: "4. أغراض المعالجة", intro: "يتم جمع بياناتك من أجل:", items: ["الرد على طلبات الاتصال الخاصة بك", "تقديم خدمات الذكاء الاصطناعي", "تحسين موقعنا", "إرسال اتصالات تجارية (بموافقتك)", "الامتثال للالتزامات القانونية"] },
        basis: { title: "5. الأساس القانوني", intro: "تستند المعالجة إلى:", items: ["موافقتك الصريحة", "تنفيذ العقد", "مصلحتنا المشروعة", "الالتزامات القانونية"] },
        retention: { title: "6. مدة الاحتفاظ", content: "يتم الاحتفاظ ببياناتك للمدة اللازمة، بحد أقصى 3 سنوات بعد آخر اتصال." },
        rights: { title: "7. حقوقك", intro: "وفقاً للائحة GDPR، لديك الحقوق التالية:", access: "حق الوصول", accessDesc: "الحصول على نسخة من بياناتك", rectification: "حق التصحيح", rectificationDesc: "تصحيح البيانات غير الدقيقة", erasure: "حق الحذف", erasureDesc: "طلب حذف بياناتك", restriction: "حق التقييد", restrictionDesc: "تقييد المعالجة", portability: "حق النقل", portabilityDesc: "الحصول على بياناتك بتنسيق منظم", objection: "حق الاعتراض", objectionDesc: "الاعتراض على المعالجة", contact: "لممارسة هذه الحقوق، اتصل بنا:" },
        security: { title: "8. الأمان", content: "ننفذ تدابير تقنية وتنظيمية مناسبة لحماية بياناتك." },
        complaint: { title: "9. الشكوى", content: "يمكنك تقديم شكوى إلى CNIL: www.cnil.fr" },
      },
    },
    cgv: {
      title: "الشروط والأحكام",
      sections: {
        object: { title: "1. الغرض", content: "تحكم هذه الشروط العلاقات التعاقدية بين {company} وعملائها لخدمات الذكاء الاصطناعي وتطوير البرمجيات والحلول التجارية." },
        provider: { title: "2. المزود", company: "الشركة", siret: "SIRET", address: "العنوان" },
        services: { title: "3. الخدمات المقدمة", intro: "{company} تقدم الخدمات التالية:", items: ["وكلاء ذكاء اصطناعي متخصصون", "تطبيقات أعمال مخصصة (Prime Evolution)", "حلول الذكاء الاصطناعي للوثائق", "VEECTORIA Pulse - منصة النسخ", "استشارات وتكامل الذكاء الاصطناعي"] },
        quotes: { title: "4. العروض والطلبات", content: "جميع الخدمات تخضع لعرض أسعار مفصل." },
        pricing: { title: "5. الأسعار والدفع", content1: "الأسعار بالـيورو بدون ضريبة القيمة المضافة. ضريبة القيمة المضافة 20%. الدفع خلال 30 يوماً.", content2: "في حالة التأخير، يتم تطبيق فوائد التأخير." },
        delivery: { title: "6. التسليم والمواعيد", content: "المواعيد إرشادية. {company} تلتزم باحترام المواعيد المتفق عليها." },
        intellectual: { title: "7. الملكية الفكرية", content: "تظل التطويرات ملكاً لـ {company} حتى الدفع الكامل." },
        confidentiality: { title: "8. السرية", content: "يلتزم الطرفان بالسرية لمدة 3 سنوات بعد انتهاء العقد." },
        liability: { title: "9. تحديد المسؤولية", content: "مسؤولية {company} محدودة بقيمة العقد." },
        law: { title: "10. القانون المطبق", content: "يطبق القانون الفرنسي. المحكمة المختصة هي باريس." },
      },
    },
    cookiesPolicy: {
      title: "سياسة ملفات تعريف الارتباط",
      sections: {
        what: { title: "1. ما هو ملف تعريف الارتباط؟", content: "ملف تعريف الارتباط هو ملف نصي صغير يُوضع على جهازك عند زيارة موقع ويب." },
        types: { title: "2. ملفات تعريف الارتباط المستخدمة", intro: "يستخدم موقعنا ملفات تعريف الارتباط التالية:", essential: "ملفات تعريف الارتباط الأساسية", essentialDesc: "ضرورية لعمل الموقع.", analytics: "ملفات تعريف الارتباط التحليلية", analyticsDesc: "تساعدنا على فهم الاستخدام.", preferences: "ملفات تعريف الارتباط للتفضيلات", preferencesDesc: "تتذكر اختياراتك." },
        retention: { title: "3. مدة الاحتفاظ", content: "يتم الاحتفاظ بملفات تعريف الارتباط لمدة أقصاها 13 شهراً." },
        management: { title: "4. إدارة ملفات تعريف الارتباط", intro: "يمكنك تغيير تفضيلاتك في أي وقت:", items: ["Chrome: الإعدادات → الخصوصية → ملفات تعريف الارتباط", "Firefox: الخيارات → الخصوصية → ملفات تعريف الارتباط", "Safari: التفضيلات → الخصوصية → ملفات تعريف الارتباط", "Edge: الإعدادات → ملفات تعريف الارتباط"] },
        contact: { title: "5. الاتصال", content: "للأسئلة حول ملفات تعريف الارتباط، اتصل بنا:" },
      },
    },
  },
};
